import { Navigate } from 'react-router-dom';
import apiService from '../services/api';
import { getPortalPathForUser } from '../utils/portalRouting';

const EmbedTesterRoute = ({ children }) => {
  const isAuthenticated = apiService.isAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/login/" replace />;
  }

  const user = apiService.getCurrentUser();
  if (user && !user.is_embed_tester) {
    return <Navigate to={getPortalPathForUser(user)} replace />;
  }

  return children;
};

export default EmbedTesterRoute;
